import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb as BreadcrumbContainer, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function Breadcrumb() {
  return <section id="breadcrumb" className="bg-background border-b border-[#F2F2F2] py-4 md:py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 w-full">
        <BreadcrumbContainer>
          <BreadcrumbList className="font-sans text-xs sm:text-sm md:text-base gap-2 sm:gap-3 md:gap-4">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="text-foreground/60 hover:text-foreground">
                <Link to="#">Beranda</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            
            <BreadcrumbSeparator className="text-[#F2F2F2]">
              <span>/</span>
            </BreadcrumbSeparator>
            
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="text-foreground/60 hover:text-foreground">
                <Link to="#">Berita</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            
            <BreadcrumbSeparator className="text-[#F2F2F2]">
              <span>/</span>
            </BreadcrumbSeparator>
            
            <BreadcrumbItem>
              <BreadcrumbPage className="text-foreground">Artikel Klarifikasi</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </BreadcrumbContainer>
      </div>
    </section>;
}